import { useEffect } from "react";
import { useListContext } from "../contexts/ListContext";
import { useGuest } from "../contexts/GuestContext";
import { guestHasAnyAlert, syncGuestAlertProfile } from "../lib/guestAlerts";

/** Keeps an opted-in guest's server alert profile in sync with their local list. */
export default function GuestAlertSync() {
  const { isGuest } = useGuest();
  const { lists } = useListContext();

  useEffect(() => {
    if (!isGuest || !guestHasAnyAlert()) return;
    const t = setTimeout(() => { syncGuestAlertProfile().catch(() => {}); }, 3000);
    return () => clearTimeout(t);
  }, [isGuest, lists]);

  return null;
}
